<template>
  <div class="video-page-wrapper">
    <IphoneVideo
      :video-name="require('@/assets/videos/wall_buttons.mp4')"
    ></IphoneVideo>
    <div class="video-page-texts">
      <div>
        <h3>{{ $t("pages.wall-buttons.subtitle1") }}</h3>
        <p>{{ $t("pages.wall-buttons.text1") }}</p>
        <div class="items">
          <div class="item" v-for="(trigger, i) in triggers" :key="i">
            <img :src="require(`@/assets/icons/${trigger.icon}.svg`)" />
            <p>{{ trigger.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WallButtons",
  data() {
    return {
      triggers: [
        { icon: "wall-buttons", text: this.$t("pages.wall-buttons.shortPress") },
        { icon: "wall-buttons", text: this.$t("pages.wall-buttons.longPress") },
        { icon: "wall-buttons", text: this.$t("pages.wall-buttons.doublePress") }
      ],
    };
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.items {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 60px;
  justify-content: flex-start;
  img {
    width: 50px;
    height: 50px;
  }
  p {
    text-align: center;
    margin-bottom: 0;
    color: $color-gray;
    font-size: 14px;
  }
  .item {
    width: 100px;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 5px 5px;
  }
}
@media only screen and (max-width: $screen-md) {
  .items {
    margin-bottom: 0px;
    margin-top: 20px;
  }
}
</style>
